import React from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

const BBCountryMap = dynamic(() => import('../BBCountryMap'), {
  ssr: false,
});

import styles from './index.module.scss';

const BBMapWithCountries = ({ behaviorSettings = null, uuid = null, ...props }) => (
  <div
    className={`bb bb-map-with-countries ${
      styles['bb-map-with-countries']
    } ${generateClassNameByBehaviorSettings(behaviorSettings)}`}
    id={uuid}
  >
    <div className={`bb ${styles['bb-map-with-countries__content']}`}>
      <div className="container">
        <BBCountryMap
          {...props}
          height={500}
          projectionConfig={{ scale: 100, rotation: [-10, 0, 0] }}
        />
      </div>
    </div>
  </div>
);

BBMapWithCountries.propTypes = {
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBMapWithCountries;
